<template>
  <div>
    <wui-dropdown
      v-if="files.length > 1"
      direction="bottom"
      plain
      data-test="images-slider-download-dropdown"
      class="w-full z-20"
      close-on-click-outside
    >
      <template #activator="{ toggle }">
        <wui-btn
          data-test="images-slider-download-btn"
          variant="neut"
          state="alpha"
          prepend-icon="downloadM"
          icon
          :size="32"
          @click="toggle"
        />
      </template>
      <template #default="{ close }">
        <wui-card
          class="z-20"
          state="text"
          shadow="overflow"
        >
          <wui-list>
            <wui-list-item
              class="text-nowrap"
              @click="currentFile && download(currentFile, PREFIX), close"
            >
              {{ $t('common.saveFile') }}
            </wui-list-item>
            <wui-list-item
              class="text-nowrap"
              @click="download(files, PREFIX), close"
            >
              {{ $t('common.saveAllFiles', {quantity: files.length }) }}
            </wui-list-item>
          </wui-list>
        </wui-card>
      </template>
    </wui-dropdown>
    <wui-btn
      v-else
      data-test="images-slider-download-btn"
      variant="neut"
      state="alpha"
      prepend-icon="downloadM"
      icon
      :size="32"
      @click="currentFile && download(currentFile, PREFIX)"
    />
  </div>
</template>

<script setup lang="ts">
import { WuiBtn, WuiCard, WuiDropdown, WuiList, WuiListItem } from '@wui/common-library'
import { IMFile } from '@wui/im'
import { computed } from 'vue'

import type { NonEmptyArray } from '@/shared/types/non-empty-array'
import { download } from '@/shared/utils/download-files'

const props = defineProps<{
    currentIndex: number,
    files: NonEmptyArray<IMFile>,
  }>()

const PREFIX = '/files/'

const currentFile = computed(() => {
  if (props.currentIndex < 0 || props.currentIndex >= props.files.length) {
    return undefined
  }
  return props.files[props.currentIndex]
})

</script>

